// GENERATED FILE - DO NOT MODIFY
import { WorkOrderPriorityModel } from "api/models/company/workorder/work-order-priority-model";
import { PagingInfo } from "api/paging-info";
import BaseProxy from "api/proxies/base-proxy";
import ModelDateTransformer from "api/util/model-date-transformer";
import { autoinject } from "aurelia-framework";
import { ApiHelper } from "helpers/api-helper";
import { HttpClientFactory } from "http-client/http-client-factory";
import { HttpClientRequestConfig } from "http-client/http-client-request-config";

@autoinject()
export class WorkOrderPriorityProxy extends BaseProxy {
    constructor(modelDateTransformer: ModelDateTransformer, httpClientFactory: HttpClientFactory, apiHelper: ApiHelper) {
        super(modelDateTransformer, httpClientFactory, apiHelper);
    }

    public async GetPriorities(filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<WorkOrderPriorityModel[] | null> {
        const uri = this.buildUri(
            "/workorders/priorities",
            null,
            { filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: WorkOrderPriorityModel[] | null = await this.get<WorkOrderPriorityModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.Workorder.WorkOrderPriorityModel");
        return data;
    }
}
